import {
  BlockWrapper,
  ChildrenBlock,
  defineBlock,
  smartProps,
  useEditor,
  useInspectorControl,
} from "@smartfire/js-block-engine";
import style from "./block.module.scss";
import { lazy } from "react";
import { InnerBlocks } from "@wordpress/block-editor";
import clsx from "clsx";

const InspectorLazy = lazy(() => import("./Inspector"));

function Block({ backgroundImage, otherClass, handleClick }) {
  useInspectorControl(InspectorLazy, []);
  const { isEditing } = useEditor();

  return (
    <BlockWrapper.Div
      className={clsx(style.block, otherClass)}
      style={{
        background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00)0%, rgba(0, 0, 0, 0.60)100%), center/cover no-repeat url(${
          backgroundImage && backgroundImage.url
        })`,
      }}
      onClick={handleClick}
    >
      {isEditing ? (
        <InnerBlocks
          allowedBlocks={["core/paragraph", "core/heading"]}
          template={[
            [
              "core/heading",
              {
                content: "L’ALPE D’HUEZ",
                placeholder: "My placeholder",
              },
            ],
            [
              "core/paragraph",
              {
                content:
                  "Perchée à 1860 mètres d'altitude dans les Alpes françaises, elle offre un panorama spectaculaire sur le Parc National des Écrins. Avec plus de 250 kilomètres de pistes, dont la célèbre Sarenne, la plus longue piste noire du monde, l'Alpe d'Huez est un paradis pour les amateurs de ski et de snowboard.",
                placeholder: "Renseigner du texte...",
              },
            ],
            [
              "smartfire/button",
              {
                text: "Explorer",
                mode: "ghost",
              },
            ],
          ]}
        />
      ) : (
        <ChildrenBlock />
      )}
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    backgroundImage: smartProps.image,
  },
  setup: {
    title: "Explore Item",
    parent: ["smartfire/explore-slider"],
  },
});
